import type { TranslationDict } from '../en';

const ar: TranslationDict = {
  'header.buy': 'شراء',
  'header.sell': 'بيع',
  'spend.label': 'تنفق',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'تحصل على',
  'payment.label': 'طريقة الدفع',
  'payment.select': 'اختيار',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'لا توجد طرق دفع لهذا الزوج',
  'wallet.label': 'عنوان محفظة الاستلام',
  'wallet.placeholderBuy': 'أدخل عنوان الاستلام الخاص بك',
  'wallet.placeholderSell': 'أدخل عنوان الإرسال الخاص بك',
  'wallet.validating': 'جارٍ التحقق من العنوان...',
  'wallet.invalid': 'أدخل عنوان محفظة صالح',
  'wallet.invalidServer': 'عنوان محفظة غير صالح',
  'cta.buy': 'شراء {crypto}',
  'cta.sell': 'بيع {crypto}',
  'cta.gettingPrice': 'جارٍ الحصول على أفضل سعر...',
  'cta.processing': 'جارٍ المعالجة...',
  'footer.poweredBy': 'مدعوم من ',
  'footer.brand': 'NowRamp',
  'rate.title': 'تفاصيل السعر',
  'rate.close': 'إغلاق',
  'rate.updatesIn': 'يتم تحديث السعر خلال 00:{seconds}',
  'rate.noQuote': 'لا يوجد عرض سعر متاح',
  'rate.exchangeRate': 'سعر الصرف',
  'rate.processingFee': 'رسوم المعالجة',
  'rate.networkFee': 'رسوم الشبكة',
  'rate.provider': 'المزود',
  'toast.orderCreated': 'تم إنشاء الطلب',
  'toast.redirecting': 'جارٍ التوجيه إلى الدفع...',
  'toast.orderFailed': 'فشل الطلب',
  'toast.couldNotCreate': 'تعذّر إنشاء الطلب',
  'toast.quoteError': 'خطأ في عرض السعر',
  'toast.noProviders': 'لا يوجد مزودون',
  'toast.somethingWrong': 'حدث خطأ ما',
  'error.amountZero': 'يجب أن يكون المبلغ أكبر من 0',
  'error.minAmountFiat': 'الحد الأدنى للمبلغ هو {min} {currency}',
  'error.minAmountCrypto': 'الحد الأدنى للمبلغ هو {min} {currency}',
  'error.noProviders': 'لا يوجد مزودون متاحون لهذا المزيج',
  'error.currencyUnavailableBuy': 'هذه العملة غير متاحة لأوامر الشراء',
  'error.currencyUnavailableSell': 'هذه العملة غير متاحة لأوامر البيع',
  'parity.info': 'سيتم تحصيل {receiveAmount} {crypto}، وسيتم إضافة الباقي حتى {spendAmount} {fiat} إلى حسابك في {partner}',
  'redirect.secureBadge': 'دفع آمن',
  'redirect.title': 'متابعة الدفع',
  'redirect.description': 'ستتم إعادة توجيهك إلى {gateway} لإتمام الدفع.',
  'redirect.countdown': 'جارٍ التوجيه خلال {seconds}...',
  'redirect.openTab': 'فتح ACH في علامة تبويب جديدة',
  'redirect.cancel': 'إلغاء',
  'checkout.noOrder': 'لم يتم العثور على طلب',
  'checkout.goBack': 'رجوع',
  'checkout.expired': 'انتهت صلاحية الدفع',
  'checkout.expiredDesc': 'انتهت صلاحية الجلسة. يرجى المحاولة مرة أخرى.',
  'checkout.startOver': 'البدء من جديد',
  'checkout.cancel': 'إلغاء',
  'checkout.loading': 'جارٍ تحميل صفحة الدفع...',
  'checkout.iframeTitle': 'صفحة دفع المزود',
  'checkout.widgetTitle': 'صفحة الدفع',
  'checkout.unknownMethod': 'طريقة دفع غير معروفة',
  'processing.default': 'جارٍ معالجة طلبك...',
  'processing.pending': 'في انتظار تأكيد الدفع...',
  'processing.active': 'جارٍ معالجة معاملتك...',
  'processing.generic': 'جارٍ المعالجة...',
  'processing.checkingStatus': 'جارٍ التحقق من الحالة...',
  'processing.orderId': 'رقم الطلب',
  'processing.provider': 'المزود',
  'processing.amount': 'المبلغ',
  'processing.receiving': 'الاستلام',
  'processing.network': 'الشبكة',
  'processing.toAddress': 'عنوان الوجهة',
  'processing.usuallyMinutes': 'عادةً ما يستغرق هذا بضع دقائق.',
  'processing.safeToClose': 'يمكنك إغلاق هذه الصفحة بأمان - سنرسل لك بريدًا إلكترونيًا عند الانتهاء.',
  'complete.buyTitle': 'تمت عملية الشراء!',
  'complete.sellTitle': 'تمت عملية البيع!',
  'complete.buyDesc': 'تم إرسال {crypto} إلى محفظتك.',
  'complete.sellDesc': 'جارٍ معالجة دفعتك بعملة {fiat}.',
  'complete.amountBuy': 'المبلغ المستلم',
  'complete.amountSell': 'المبلغ المباع',
  'complete.paidBuy': 'المبلغ المدفوع',
  'complete.paidSell': 'مبلغ الدفعة',
  'complete.network': 'الشبكة',
  'complete.wallet': 'المحفظة',
  'complete.transaction': 'المعاملة',
  'complete.provider': 'المزود',
  'complete.orderId': 'رقم الطلب',
  'complete.completed': 'مكتمل',
  'complete.viewExplorer': 'عرض في المستكشف',
  'complete.done': 'تم',
  'errorStep.failed': 'فشل الدفع',
  'errorStep.cancelled': 'تم إلغاء الطلب',
  'errorStep.expired': 'انتهت صلاحية الطلب',
  'errorStep.refunded': 'تم استرداد الطلب',
  'errorStep.unknown': 'حدث خطأ ما',
  'errorStep.failedBuy': 'تعذّرت معالجة دفعتك. يرجى المحاولة مرة أخرى أو استخدام طريقة دفع مختلفة.',
  'errorStep.failedSell': 'تعذّرت معالجة عملية البيع. يرجى المحاولة مرة أخرى.',
  'errorStep.cancelledBuy': 'تم إلغاء طلبك. لم تتم معالجة أي دفعة.',
  'errorStep.cancelledSell': 'تم إلغاء عملية البيع. لم يتم تحويل أي عملة رقمية.',
  'errorStep.expiredBuy': 'انتهت صلاحية طلبك. يرجى بدء عملية شراء جديدة.',
  'errorStep.expiredSell': 'انتهت صلاحية طلبك. يرجى بدء عملية بيع جديدة.',
  'errorStep.refundedBuy': 'تم استرداد دفعتك. ستظهر الأموال في حسابك خلال 5-10 أيام عمل.',
  'errorStep.refundedSell': 'تم إعادة عملتك الرقمية. ستظهر الأموال في محفظتك قريبًا.',
  'errorStep.genericDesc': 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.',
  'errorStep.orderId': 'رقم الطلب',
  'errorStep.tryAgain': 'إعادة المحاولة',
  'errorStep.startOver': 'البدء من جديد',
  'errorStep.return': 'رجوع',
  'errorStep.needHelp': 'تحتاج مساعدة؟ تواصل مع ',
  'errorStep.reference': 'المرجع: {orderId}',
  'confirm.buyTitle': 'تأكيد الشراء',
  'confirm.sellTitle': 'تأكيد البيع',
  'confirm.loading': 'جارٍ التحميل...',
  'confirm.provider': 'المزود',
  'confirm.youPay': 'تدفع',
  'confirm.youSell': 'تبيع',
  'confirm.youReceive': 'تستلم',
  'confirm.wallet': 'المحفظة',
  'confirm.network': 'الشبكة',
  'confirm.refundAddress': 'عنوان الاسترداد',
  'confirm.parityNote': 'قد يختلف المبلغ المحصّل من المزود. سيتم إضافة الباقي حتى {amount} {crypto} إلى حسابك في {partner}.',
  'confirm.processing': 'جارٍ المعالجة...',
  'confirm.confirmPay': 'تأكيد والدفع',
  'confirm.confirmSell': 'تأكيد والبيع',
  'confirm.payout': 'دفعة {currency}',
  'modal.selectFiat': 'اختيار العملة الورقية',
  'modal.selectCrypto': 'اختيار العملة الرقمية',
  'modal.choosePayment': 'اختيار طريقة الدفع',
  'modal.selectCountry': 'اختيار بلدك',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'شائع',
  'modal.recommended': 'موصى به',
  'modal.noCurrencies': 'لم يتم العثور على عملات',
  'modal.noPaymentMethods': 'لم يتم العثور على طرق دفع',
  'modal.noCountries': 'لم يتم العثور على دول',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'الموقع',
  'settings.darkMode': 'الوضع الداكن',
  'settings.privacy': 'سياسة الخصوصية',
  'settings.terms': 'شروط الاستخدام',
  'settings.language': 'اللغة',
  // ─── Additional ───
  'modal.chooseRamp': 'اختيار Ramp',
  'modal.bestPrice': 'أفضل سعر',
  'modal.noQuotes': 'لا توجد عروض أسعار متاحة لهذا الطلب',
  'modal.noProvidersFound': 'لم يتم العثور على مزودين',
  'payment.unavailableFor': 'لا توجد طرق دفع متاحة لـ {currency}',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'فشل إنشاء الطلب',
  'errorStep.returnToMerchant': 'العودة إلى التاجر',
  'confirm.cryptoOnNetwork': '{crypto} على شبكة {network}',
  'payment.name.card': 'بطاقة',
  'payment.name.bankTransfer': 'تحويل بنكي',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default ar;
